/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationForm,
    ApplicationFormFromJSON,
    ApplicationFormToJSON,
    CallData,
    CallDataFromJSON,
    CallDataToJSON,
    Debt,
    DebtFromJSON,
    DebtToJSON,
    FormResendMessage,
    FormResendMessageFromJSON,
    FormResendMessageToJSON,
    IdmEvaluation,
    IdmEvaluationFromJSON,
    IdmEvaluationToJSON,
    IncomesAndExpenses,
    IncomesAndExpensesFromJSON,
    IncomesAndExpensesToJSON,
    Lead,
    LeadFromJSON,
    LeadToJSON,
    LeadClose,
    LeadCloseFromJSON,
    LeadCloseToJSON,
    LeadDetail,
    LeadDetailFromJSON,
    LeadDetailToJSON,
    Offers,
    OffersFromJSON,
    OffersToJSON,
    PaginatedLeadList,
    PaginatedLeadListFromJSON,
    PaginatedLeadListToJSON,
    PatchedCallData,
    PatchedCallDataFromJSON,
    PatchedCallDataToJSON,
    PatchedDebt,
    PatchedDebtFromJSON,
    PatchedDebtToJSON,
    PatchedIncomesAndExpenses,
    PatchedIncomesAndExpensesFromJSON,
    PatchedIncomesAndExpensesToJSON,
} from '../models';

export interface CheckIdmEvaluationResultRequest {
    id: number;
    leadId: string;
}

export interface CloseLeadRequest {
    id: number;
    leadClose: LeadClose;
}

export interface CreateIdmEvaluationRequest {
    leadId: string;
    idmEvaluation: IdmEvaluation;
}

export interface CreateLeadOfferRequest {
    id: number;
    offers?: Offers;
}

export interface DestroyIdmEvaluationRequest {
    id: number;
    leadId: string;
}

export interface GetLeadApplicationFormRequest {
    id: number;
}

export interface LeadsCallDataCreateRequest {
    leadId: string;
    callData: CallData;
}

export interface LeadsCallDataDestroyRequest {
    id: number;
    leadId: string;
}

export interface LeadsCallDataListRequest {
    leadId: string;
    ordering?: string;
}

export interface LeadsCallDataPartialUpdateRequest {
    id: number;
    leadId: string;
    patchedCallData?: PatchedCallData;
}

export interface LeadsCallDataRetrieveRequest {
    id: number;
    leadId: string;
}

export interface LeadsCallDataUpdateRequest {
    id: number;
    leadId: string;
    callData: CallData;
}

export interface LeadsDebtCreateRequest {
    leadId: string;
    debt: Debt;
}

export interface LeadsDebtDestroyRequest {
    id: number;
    leadId: string;
}

export interface LeadsDebtListRequest {
    leadId: string;
    ordering?: string;
}

export interface LeadsDebtPartialUpdateRequest {
    id: number;
    leadId: string;
    patchedDebt?: PatchedDebt;
}

export interface LeadsDebtUpdateRequest {
    id: number;
    leadId: string;
    debt: Debt;
}

export interface LeadsIncomesExpensesCreateRequest {
    leadId: string;
    incomesAndExpenses: IncomesAndExpenses;
}

export interface LeadsIncomesExpensesDestroyRequest {
    id: number;
    leadId: string;
}

export interface LeadsIncomesExpensesListRequest {
    leadId: string;
    ordering?: string;
}

export interface LeadsIncomesExpensesPartialUpdateRequest {
    id: number;
    leadId: string;
    patchedIncomesAndExpenses?: PatchedIncomesAndExpenses;
}

export interface LeadsIncomesExpensesRetrieveRequest {
    id: number;
    leadId: string;
}

export interface LeadsIncomesExpensesUpdateRequest {
    id: number;
    leadId: string;
    incomesAndExpenses: IncomesAndExpenses;
}

export interface LeadsRetrieveRequest {
    id: number;
}

export interface ListIdmEvaluationRequest {
    leadId: string;
    ordering?: string;
}

export interface ListLeadsRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
    person?: number;
}

export interface PushLeadsorLeadRequest {
    requestBody?: { [key: string]: any; };
}

export interface PushLeadsorLeadWithContactRequest {
    requestBody?: { [key: string]: any; };
}

export interface PushSevenFinanceLeadRequest {
    requestBody?: { [key: string]: any; };
}

export interface PushVolsorLeadRequest {
    requestBody?: { [key: string]: any; };
}

export interface PushVolsorLeadWithContactRequest {
    requestBody?: { [key: string]: any; };
}

export interface ResendApplicationFormRequest {
    id: string;
    leadId: string;
    formResendMessage?: FormResendMessage;
}

/**
 * LeadsApi - interface
 * 
 * @export
 * @interface LeadsApiInterface
 */
export interface LeadsApiInterface {
    /**
     * Check result of evaluation request
     * @param {number} id A unique integer value identifying this idm evaluation.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    checkIdmEvaluationResultRaw(requestParameters: CheckIdmEvaluationResultRequest): Promise<runtime.ApiResponse<IdmEvaluation>>;

    /**
     * Check result of evaluation request
     */
    checkIdmEvaluationResult(requestParameters: CheckIdmEvaluationResultRequest): Promise<IdmEvaluation>;

    /**
     * Close Lead and lost lead in Pipedrive
     * @param {number} id A unique integer value identifying this lead.
     * @param {LeadClose} leadClose 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    closeLeadRaw(requestParameters: CloseLeadRequest): Promise<runtime.ApiResponse<LeadClose>>;

    /**
     * Close Lead and lost lead in Pipedrive
     */
    closeLead(requestParameters: CloseLeadRequest): Promise<LeadClose>;

    /**
     * 
     * @param {string} leadId 
     * @param {IdmEvaluation} idmEvaluation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    createIdmEvaluationRaw(requestParameters: CreateIdmEvaluationRequest): Promise<runtime.ApiResponse<IdmEvaluation>>;

    /**
     */
    createIdmEvaluation(requestParameters: CreateIdmEvaluationRequest): Promise<IdmEvaluation>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     * @param {number} id A unique integer value identifying this lead.
     * @param {Offers} [offers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    createLeadOfferRaw(requestParameters: CreateLeadOfferRequest): Promise<runtime.ApiResponse<Offers>>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    createLeadOffer(requestParameters: CreateLeadOfferRequest): Promise<Offers>;

    /**
     * 
     * @param {number} id A unique integer value identifying this idm evaluation.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    destroyIdmEvaluationRaw(requestParameters: DestroyIdmEvaluationRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    destroyIdmEvaluation(requestParameters: DestroyIdmEvaluationRequest): Promise<void>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     * @param {number} id A unique integer value identifying this lead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    getLeadApplicationFormRaw(requestParameters: GetLeadApplicationFormRequest): Promise<runtime.ApiResponse<ApplicationForm>>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    getLeadApplicationForm(requestParameters: GetLeadApplicationFormRequest): Promise<ApplicationForm>;

    /**
     * 
     * @param {string} leadId 
     * @param {CallData} callData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataCreateRaw(requestParameters: LeadsCallDataCreateRequest): Promise<runtime.ApiResponse<CallData>>;

    /**
     */
    leadsCallDataCreate(requestParameters: LeadsCallDataCreateRequest): Promise<CallData>;

    /**
     * 
     * @param {number} id A unique integer value identifying this call data.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataDestroyRaw(requestParameters: LeadsCallDataDestroyRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    leadsCallDataDestroy(requestParameters: LeadsCallDataDestroyRequest): Promise<void>;

    /**
     * 
     * @param {string} leadId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataListRaw(requestParameters: LeadsCallDataListRequest): Promise<runtime.ApiResponse<Array<CallData>>>;

    /**
     */
    leadsCallDataList(requestParameters: LeadsCallDataListRequest): Promise<Array<CallData>>;

    /**
     * 
     * @param {number} id A unique integer value identifying this call data.
     * @param {string} leadId 
     * @param {PatchedCallData} [patchedCallData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataPartialUpdateRaw(requestParameters: LeadsCallDataPartialUpdateRequest): Promise<runtime.ApiResponse<CallData>>;

    /**
     */
    leadsCallDataPartialUpdate(requestParameters: LeadsCallDataPartialUpdateRequest): Promise<CallData>;

    /**
     * 
     * @param {number} id A unique integer value identifying this call data.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataRetrieveRaw(requestParameters: LeadsCallDataRetrieveRequest): Promise<runtime.ApiResponse<CallData>>;

    /**
     */
    leadsCallDataRetrieve(requestParameters: LeadsCallDataRetrieveRequest): Promise<CallData>;

    /**
     * 
     * @param {number} id A unique integer value identifying this call data.
     * @param {string} leadId 
     * @param {CallData} callData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsCallDataUpdateRaw(requestParameters: LeadsCallDataUpdateRequest): Promise<runtime.ApiResponse<CallData>>;

    /**
     */
    leadsCallDataUpdate(requestParameters: LeadsCallDataUpdateRequest): Promise<CallData>;

    /**
     * 
     * @param {string} leadId 
     * @param {Debt} debt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsDebtCreateRaw(requestParameters: LeadsDebtCreateRequest): Promise<runtime.ApiResponse<Debt>>;

    /**
     */
    leadsDebtCreate(requestParameters: LeadsDebtCreateRequest): Promise<Debt>;

    /**
     * 
     * @param {number} id A unique integer value identifying this debt.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsDebtDestroyRaw(requestParameters: LeadsDebtDestroyRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    leadsDebtDestroy(requestParameters: LeadsDebtDestroyRequest): Promise<void>;

    /**
     * 
     * @param {string} leadId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsDebtListRaw(requestParameters: LeadsDebtListRequest): Promise<runtime.ApiResponse<Array<Debt>>>;

    /**
     */
    leadsDebtList(requestParameters: LeadsDebtListRequest): Promise<Array<Debt>>;

    /**
     * 
     * @param {number} id A unique integer value identifying this debt.
     * @param {string} leadId 
     * @param {PatchedDebt} [patchedDebt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsDebtPartialUpdateRaw(requestParameters: LeadsDebtPartialUpdateRequest): Promise<runtime.ApiResponse<Debt>>;

    /**
     */
    leadsDebtPartialUpdate(requestParameters: LeadsDebtPartialUpdateRequest): Promise<Debt>;

    /**
     * 
     * @param {number} id A unique integer value identifying this debt.
     * @param {string} leadId 
     * @param {Debt} debt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsDebtUpdateRaw(requestParameters: LeadsDebtUpdateRequest): Promise<runtime.ApiResponse<Debt>>;

    /**
     */
    leadsDebtUpdate(requestParameters: LeadsDebtUpdateRequest): Promise<Debt>;

    /**
     * 
     * @param {string} leadId 
     * @param {IncomesAndExpenses} incomesAndExpenses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesCreateRaw(requestParameters: LeadsIncomesExpensesCreateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>>;

    /**
     */
    leadsIncomesExpensesCreate(requestParameters: LeadsIncomesExpensesCreateRequest): Promise<IncomesAndExpenses>;

    /**
     * 
     * @param {number} id A unique integer value identifying this incomes and expenses.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesDestroyRaw(requestParameters: LeadsIncomesExpensesDestroyRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    leadsIncomesExpensesDestroy(requestParameters: LeadsIncomesExpensesDestroyRequest): Promise<void>;

    /**
     * 
     * @param {string} leadId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesListRaw(requestParameters: LeadsIncomesExpensesListRequest): Promise<runtime.ApiResponse<Array<IncomesAndExpenses>>>;

    /**
     */
    leadsIncomesExpensesList(requestParameters: LeadsIncomesExpensesListRequest): Promise<Array<IncomesAndExpenses>>;

    /**
     * 
     * @param {number} id A unique integer value identifying this incomes and expenses.
     * @param {string} leadId 
     * @param {PatchedIncomesAndExpenses} [patchedIncomesAndExpenses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesPartialUpdateRaw(requestParameters: LeadsIncomesExpensesPartialUpdateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>>;

    /**
     */
    leadsIncomesExpensesPartialUpdate(requestParameters: LeadsIncomesExpensesPartialUpdateRequest): Promise<IncomesAndExpenses>;

    /**
     * 
     * @param {number} id A unique integer value identifying this incomes and expenses.
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesRetrieveRaw(requestParameters: LeadsIncomesExpensesRetrieveRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>>;

    /**
     */
    leadsIncomesExpensesRetrieve(requestParameters: LeadsIncomesExpensesRetrieveRequest): Promise<IncomesAndExpenses>;

    /**
     * 
     * @param {number} id A unique integer value identifying this incomes and expenses.
     * @param {string} leadId 
     * @param {IncomesAndExpenses} incomesAndExpenses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsIncomesExpensesUpdateRaw(requestParameters: LeadsIncomesExpensesUpdateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>>;

    /**
     */
    leadsIncomesExpensesUpdate(requestParameters: LeadsIncomesExpensesUpdateRequest): Promise<IncomesAndExpenses>;

    /**
     * 
     * @param {number} id A unique integer value identifying this lead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    leadsRetrieveRaw(requestParameters: LeadsRetrieveRequest): Promise<runtime.ApiResponse<LeadDetail>>;

    /**
     */
    leadsRetrieve(requestParameters: LeadsRetrieveRequest): Promise<LeadDetail>;

    /**
     * 
     * @param {string} leadId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    listIdmEvaluationRaw(requestParameters: ListIdmEvaluationRequest): Promise<runtime.ApiResponse<Array<IdmEvaluation>>>;

    /**
     */
    listIdmEvaluation(requestParameters: ListIdmEvaluationRequest): Promise<Array<IdmEvaluation>>;

    /**
     * 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {number} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    listLeadsRaw(requestParameters: ListLeadsRequest): Promise<runtime.ApiResponse<PaginatedLeadList>>;

    /**
     */
    listLeads(requestParameters: ListLeadsRequest): Promise<PaginatedLeadList>;

    /**
     * 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    pushLeadsorLeadRaw(requestParameters: PushLeadsorLeadRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    pushLeadsorLead(requestParameters: PushLeadsorLeadRequest): Promise<Lead>;

    /**
     * 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    pushLeadsorLeadWithContactRaw(requestParameters: PushLeadsorLeadWithContactRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    pushLeadsorLeadWithContact(requestParameters: PushLeadsorLeadWithContactRequest): Promise<Lead>;

    /**
     * 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    pushSevenFinanceLeadRaw(requestParameters: PushSevenFinanceLeadRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    pushSevenFinanceLead(requestParameters: PushSevenFinanceLeadRequest): Promise<Lead>;

    /**
     * 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    pushVolsorLeadRaw(requestParameters: PushVolsorLeadRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    pushVolsorLead(requestParameters: PushVolsorLeadRequest): Promise<Lead>;

    /**
     * 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    pushVolsorLeadWithContactRaw(requestParameters: PushVolsorLeadWithContactRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    pushVolsorLeadWithContact(requestParameters: PushVolsorLeadWithContactRequest): Promise<Lead>;

    /**
     * 
     * @param {string} id 
     * @param {string} leadId 
     * @param {FormResendMessage} [formResendMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApiInterface
     */
    resendApplicationFormRaw(requestParameters: ResendApplicationFormRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    resendApplicationForm(requestParameters: ResendApplicationFormRequest): Promise<void>;

}

/**
 * 
 */
export class LeadsApi extends runtime.BaseAPI implements LeadsApiInterface {

    /**
     * Check result of evaluation request
     */
    async checkIdmEvaluationResultRaw(requestParameters: CheckIdmEvaluationResultRequest): Promise<runtime.ApiResponse<IdmEvaluation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling checkIdmEvaluationResult.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling checkIdmEvaluationResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/idm-evaluation/{id}/check-result/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdmEvaluationFromJSON(jsonValue));
    }

    /**
     * Check result of evaluation request
     */
    async checkIdmEvaluationResult(requestParameters: CheckIdmEvaluationResultRequest): Promise<IdmEvaluation> {
        const response = await this.checkIdmEvaluationResultRaw(requestParameters);
        return await response.value();
    }

    /**
     * Close Lead and lost lead in Pipedrive
     */
    async closeLeadRaw(requestParameters: CloseLeadRequest): Promise<runtime.ApiResponse<LeadClose>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling closeLead.');
        }

        if (requestParameters.leadClose === null || requestParameters.leadClose === undefined) {
            throw new runtime.RequiredError('leadClose','Required parameter requestParameters.leadClose was null or undefined when calling closeLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{id}/close/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeadCloseToJSON(requestParameters.leadClose),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadCloseFromJSON(jsonValue));
    }

    /**
     * Close Lead and lost lead in Pipedrive
     */
    async closeLead(requestParameters: CloseLeadRequest): Promise<LeadClose> {
        const response = await this.closeLeadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createIdmEvaluationRaw(requestParameters: CreateIdmEvaluationRequest): Promise<runtime.ApiResponse<IdmEvaluation>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createIdmEvaluation.');
        }

        if (requestParameters.idmEvaluation === null || requestParameters.idmEvaluation === undefined) {
            throw new runtime.RequiredError('idmEvaluation','Required parameter requestParameters.idmEvaluation was null or undefined when calling createIdmEvaluation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/idm-evaluation/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdmEvaluationToJSON(requestParameters.idmEvaluation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdmEvaluationFromJSON(jsonValue));
    }

    /**
     */
    async createIdmEvaluation(requestParameters: CreateIdmEvaluationRequest): Promise<IdmEvaluation> {
        const response = await this.createIdmEvaluationRaw(requestParameters);
        return await response.value();
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async createLeadOfferRaw(requestParameters: CreateLeadOfferRequest): Promise<runtime.ApiResponse<Offers>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createLeadOffer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{id}/offer/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OffersToJSON(requestParameters.offers),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OffersFromJSON(jsonValue));
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async createLeadOffer(requestParameters: CreateLeadOfferRequest): Promise<Offers> {
        const response = await this.createLeadOfferRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async destroyIdmEvaluationRaw(requestParameters: DestroyIdmEvaluationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling destroyIdmEvaluation.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling destroyIdmEvaluation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/idm-evaluation/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async destroyIdmEvaluation(requestParameters: DestroyIdmEvaluationRequest): Promise<void> {
        await this.destroyIdmEvaluationRaw(requestParameters);
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async getLeadApplicationFormRaw(requestParameters: GetLeadApplicationFormRequest): Promise<runtime.ApiResponse<ApplicationForm>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLeadApplicationForm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{id}/application_form/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormFromJSON(jsonValue));
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async getLeadApplicationForm(requestParameters: GetLeadApplicationFormRequest): Promise<ApplicationForm> {
        const response = await this.getLeadApplicationFormRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsCallDataCreateRaw(requestParameters: LeadsCallDataCreateRequest): Promise<runtime.ApiResponse<CallData>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataCreate.');
        }

        if (requestParameters.callData === null || requestParameters.callData === undefined) {
            throw new runtime.RequiredError('callData','Required parameter requestParameters.callData was null or undefined when calling leadsCallDataCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CallDataToJSON(requestParameters.callData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CallDataFromJSON(jsonValue));
    }

    /**
     */
    async leadsCallDataCreate(requestParameters: LeadsCallDataCreateRequest): Promise<CallData> {
        const response = await this.leadsCallDataCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsCallDataDestroyRaw(requestParameters: LeadsCallDataDestroyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsCallDataDestroy.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async leadsCallDataDestroy(requestParameters: LeadsCallDataDestroyRequest): Promise<void> {
        await this.leadsCallDataDestroyRaw(requestParameters);
    }

    /**
     */
    async leadsCallDataListRaw(requestParameters: LeadsCallDataListRequest): Promise<runtime.ApiResponse<Array<CallData>>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CallDataFromJSON));
    }

    /**
     */
    async leadsCallDataList(requestParameters: LeadsCallDataListRequest): Promise<Array<CallData>> {
        const response = await this.leadsCallDataListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsCallDataPartialUpdateRaw(requestParameters: LeadsCallDataPartialUpdateRequest): Promise<runtime.ApiResponse<CallData>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsCallDataPartialUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedCallDataToJSON(requestParameters.patchedCallData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CallDataFromJSON(jsonValue));
    }

    /**
     */
    async leadsCallDataPartialUpdate(requestParameters: LeadsCallDataPartialUpdateRequest): Promise<CallData> {
        const response = await this.leadsCallDataPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsCallDataRetrieveRaw(requestParameters: LeadsCallDataRetrieveRequest): Promise<runtime.ApiResponse<CallData>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsCallDataRetrieve.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CallDataFromJSON(jsonValue));
    }

    /**
     */
    async leadsCallDataRetrieve(requestParameters: LeadsCallDataRetrieveRequest): Promise<CallData> {
        const response = await this.leadsCallDataRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsCallDataUpdateRaw(requestParameters: LeadsCallDataUpdateRequest): Promise<runtime.ApiResponse<CallData>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsCallDataUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsCallDataUpdate.');
        }

        if (requestParameters.callData === null || requestParameters.callData === undefined) {
            throw new runtime.RequiredError('callData','Required parameter requestParameters.callData was null or undefined when calling leadsCallDataUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/call-data/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CallDataToJSON(requestParameters.callData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CallDataFromJSON(jsonValue));
    }

    /**
     */
    async leadsCallDataUpdate(requestParameters: LeadsCallDataUpdateRequest): Promise<CallData> {
        const response = await this.leadsCallDataUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsDebtCreateRaw(requestParameters: LeadsDebtCreateRequest): Promise<runtime.ApiResponse<Debt>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsDebtCreate.');
        }

        if (requestParameters.debt === null || requestParameters.debt === undefined) {
            throw new runtime.RequiredError('debt','Required parameter requestParameters.debt was null or undefined when calling leadsDebtCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/debt/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DebtToJSON(requestParameters.debt),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DebtFromJSON(jsonValue));
    }

    /**
     */
    async leadsDebtCreate(requestParameters: LeadsDebtCreateRequest): Promise<Debt> {
        const response = await this.leadsDebtCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsDebtDestroyRaw(requestParameters: LeadsDebtDestroyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsDebtDestroy.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsDebtDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/debt/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async leadsDebtDestroy(requestParameters: LeadsDebtDestroyRequest): Promise<void> {
        await this.leadsDebtDestroyRaw(requestParameters);
    }

    /**
     */
    async leadsDebtListRaw(requestParameters: LeadsDebtListRequest): Promise<runtime.ApiResponse<Array<Debt>>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsDebtList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/debt/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DebtFromJSON));
    }

    /**
     */
    async leadsDebtList(requestParameters: LeadsDebtListRequest): Promise<Array<Debt>> {
        const response = await this.leadsDebtListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsDebtPartialUpdateRaw(requestParameters: LeadsDebtPartialUpdateRequest): Promise<runtime.ApiResponse<Debt>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsDebtPartialUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsDebtPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/debt/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDebtToJSON(requestParameters.patchedDebt),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DebtFromJSON(jsonValue));
    }

    /**
     */
    async leadsDebtPartialUpdate(requestParameters: LeadsDebtPartialUpdateRequest): Promise<Debt> {
        const response = await this.leadsDebtPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsDebtUpdateRaw(requestParameters: LeadsDebtUpdateRequest): Promise<runtime.ApiResponse<Debt>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsDebtUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsDebtUpdate.');
        }

        if (requestParameters.debt === null || requestParameters.debt === undefined) {
            throw new runtime.RequiredError('debt','Required parameter requestParameters.debt was null or undefined when calling leadsDebtUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/debt/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DebtToJSON(requestParameters.debt),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DebtFromJSON(jsonValue));
    }

    /**
     */
    async leadsDebtUpdate(requestParameters: LeadsDebtUpdateRequest): Promise<Debt> {
        const response = await this.leadsDebtUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsIncomesExpensesCreateRaw(requestParameters: LeadsIncomesExpensesCreateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesCreate.');
        }

        if (requestParameters.incomesAndExpenses === null || requestParameters.incomesAndExpenses === undefined) {
            throw new runtime.RequiredError('incomesAndExpenses','Required parameter requestParameters.incomesAndExpenses was null or undefined when calling leadsIncomesExpensesCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IncomesAndExpensesToJSON(requestParameters.incomesAndExpenses),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IncomesAndExpensesFromJSON(jsonValue));
    }

    /**
     */
    async leadsIncomesExpensesCreate(requestParameters: LeadsIncomesExpensesCreateRequest): Promise<IncomesAndExpenses> {
        const response = await this.leadsIncomesExpensesCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsIncomesExpensesDestroyRaw(requestParameters: LeadsIncomesExpensesDestroyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsIncomesExpensesDestroy.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async leadsIncomesExpensesDestroy(requestParameters: LeadsIncomesExpensesDestroyRequest): Promise<void> {
        await this.leadsIncomesExpensesDestroyRaw(requestParameters);
    }

    /**
     */
    async leadsIncomesExpensesListRaw(requestParameters: LeadsIncomesExpensesListRequest): Promise<runtime.ApiResponse<Array<IncomesAndExpenses>>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IncomesAndExpensesFromJSON));
    }

    /**
     */
    async leadsIncomesExpensesList(requestParameters: LeadsIncomesExpensesListRequest): Promise<Array<IncomesAndExpenses>> {
        const response = await this.leadsIncomesExpensesListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsIncomesExpensesPartialUpdateRaw(requestParameters: LeadsIncomesExpensesPartialUpdateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsIncomesExpensesPartialUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedIncomesAndExpensesToJSON(requestParameters.patchedIncomesAndExpenses),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IncomesAndExpensesFromJSON(jsonValue));
    }

    /**
     */
    async leadsIncomesExpensesPartialUpdate(requestParameters: LeadsIncomesExpensesPartialUpdateRequest): Promise<IncomesAndExpenses> {
        const response = await this.leadsIncomesExpensesPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsIncomesExpensesRetrieveRaw(requestParameters: LeadsIncomesExpensesRetrieveRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsIncomesExpensesRetrieve.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IncomesAndExpensesFromJSON(jsonValue));
    }

    /**
     */
    async leadsIncomesExpensesRetrieve(requestParameters: LeadsIncomesExpensesRetrieveRequest): Promise<IncomesAndExpenses> {
        const response = await this.leadsIncomesExpensesRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsIncomesExpensesUpdateRaw(requestParameters: LeadsIncomesExpensesUpdateRequest): Promise<runtime.ApiResponse<IncomesAndExpenses>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsIncomesExpensesUpdate.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling leadsIncomesExpensesUpdate.');
        }

        if (requestParameters.incomesAndExpenses === null || requestParameters.incomesAndExpenses === undefined) {
            throw new runtime.RequiredError('incomesAndExpenses','Required parameter requestParameters.incomesAndExpenses was null or undefined when calling leadsIncomesExpensesUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/incomes-expenses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IncomesAndExpensesToJSON(requestParameters.incomesAndExpenses),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IncomesAndExpensesFromJSON(jsonValue));
    }

    /**
     */
    async leadsIncomesExpensesUpdate(requestParameters: LeadsIncomesExpensesUpdateRequest): Promise<IncomesAndExpenses> {
        const response = await this.leadsIncomesExpensesUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async leadsRetrieveRaw(requestParameters: LeadsRetrieveRequest): Promise<runtime.ApiResponse<LeadDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling leadsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadDetailFromJSON(jsonValue));
    }

    /**
     */
    async leadsRetrieve(requestParameters: LeadsRetrieveRequest): Promise<LeadDetail> {
        const response = await this.leadsRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listIdmEvaluationRaw(requestParameters: ListIdmEvaluationRequest): Promise<runtime.ApiResponse<Array<IdmEvaluation>>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling listIdmEvaluation.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/idm-evaluation/`.replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdmEvaluationFromJSON));
    }

    /**
     */
    async listIdmEvaluation(requestParameters: ListIdmEvaluationRequest): Promise<Array<IdmEvaluation>> {
        const response = await this.listIdmEvaluationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listLeadsRaw(requestParameters: ListLeadsRequest): Promise<runtime.ApiResponse<PaginatedLeadList>> {
        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.person !== undefined) {
            queryParameters['person'] = requestParameters.person;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLeadListFromJSON(jsonValue));
    }

    /**
     */
    async listLeads(requestParameters: ListLeadsRequest): Promise<PaginatedLeadList> {
        const response = await this.listLeadsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pushLeadsorLeadRaw(requestParameters: PushLeadsorLeadRequest): Promise<runtime.ApiResponse<Lead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/api/v1/leads/leadsor/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async pushLeadsorLead(requestParameters: PushLeadsorLeadRequest): Promise<Lead> {
        const response = await this.pushLeadsorLeadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pushLeadsorLeadWithContactRaw(requestParameters: PushLeadsorLeadWithContactRequest): Promise<runtime.ApiResponse<Lead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/api/v1/leads/leadsor/contact/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async pushLeadsorLeadWithContact(requestParameters: PushLeadsorLeadWithContactRequest): Promise<Lead> {
        const response = await this.pushLeadsorLeadWithContactRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pushSevenFinanceLeadRaw(requestParameters: PushSevenFinanceLeadRequest): Promise<runtime.ApiResponse<Lead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/api/v1/leads/seven-finance/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async pushSevenFinanceLead(requestParameters: PushSevenFinanceLeadRequest): Promise<Lead> {
        const response = await this.pushSevenFinanceLeadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pushVolsorLeadRaw(requestParameters: PushVolsorLeadRequest): Promise<runtime.ApiResponse<Lead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/api/v1/leads/volsor/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async pushVolsorLead(requestParameters: PushVolsorLeadRequest): Promise<Lead> {
        const response = await this.pushVolsorLeadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pushVolsorLeadWithContactRaw(requestParameters: PushVolsorLeadWithContactRequest): Promise<runtime.ApiResponse<Lead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/api/v1/leads/volsor/contact/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async pushVolsorLeadWithContact(requestParameters: PushVolsorLeadWithContactRequest): Promise<Lead> {
        const response = await this.pushVolsorLeadWithContactRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async resendApplicationFormRaw(requestParameters: ResendApplicationFormRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resendApplicationForm.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling resendApplicationForm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/leads/{leadId}/application-form/{id}/resend/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"leadId"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormResendMessageToJSON(requestParameters.formResendMessage),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resendApplicationForm(requestParameters: ResendApplicationFormRequest): Promise<void> {
        await this.resendApplicationFormRaw(requestParameters);
    }

}
